export const action='discover/movie?api_key=5f6f334d30e8d1d3ed12b35ba787d10a&with_genres=28'
export const orginals='/discover/tv?api_key=5f6f334d30e8d1d3ed12b35ba787d10a&with_networks=213'